import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { AppBar, Toolbar, IconButton, Button, ListItemText, ListItem } from '@mui/material'
import { noop } from 'lodash'
import { useTheme } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'
import { Download } from '@mui/icons-material'
import { format, parse } from 'date-fns'

import T from 'T'
import { convertDateTimeToPreferedTimezone } from 'data/dateTime/convertDateTimeToPreferedTimezone'

const ExceptionGalleryAppBar = ({ createdAt = '', photoName = '', showDownloadButton = false, onDownload = noop, onClose }) => {
  const theme = useTheme()
  const { onlyDate, onlyTime } = useMemo(() => convertDateTimeToPreferedTimezone({ dateTime: createdAt }), [createdAt])
  const date = useMemo(() => onlyDate && parse(onlyDate, 'MM/dd/yyyy', new Date()), [onlyDate])
  const formattedDate = useMemo(() => date && format(date, 'MMM dd, yyyy'), [date])

  return (
    <AppBar sx={{ position: 'relative', bgcolor: theme.palette.common.black, minHeight: '56px' }}>
      <Toolbar sx={{ minHeight: '56px' }}>
        <IconButton onClick={onClose} edge="start" color="inherit" aria-label="close">
          <CloseIcon />
        </IconButton>
        <ListItem>
          <ListItemText
            primary={photoName}
            secondary={`${formattedDate} at ${onlyTime}`}
            slotProps={{
              primary: { variant: 'h6', color: 'common.white' },
              secondary: { color: 'common.white' },
            }}
          />
        </ListItem>
        {showDownloadButton && (
          <Button variant="text" startIcon={<Download />} onClick={onDownload} edge="start" color="inherit" aria-label="close">
            {T.DOWNLOAD}
          </Button>
        )}
      </Toolbar>
    </AppBar>
  )
}

ExceptionGalleryAppBar.propTypes = {
  createdAt: PropTypes.string,
  photoName: PropTypes.string,
  showDownloadButton: PropTypes.bool,
  onDownload: PropTypes.func,
  onClose: PropTypes.func,
}

export default ExceptionGalleryAppBar
